module.exports = __webpack_public_path__ + "static/media/close-icon.88ac87a7.svg";